// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"scroll-manager_scrollWrapper__szd0T","rotation":"scroll-manager_rotation__egoO9"};